exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#detailTop[data-v-1ff9c303] {\n  width: 100%;\n  height: 5.6266rem;\n  position: relative;\n}\n#detailTop *[data-v-1ff9c303] {\n  max-width: 100%;\n  height: 5.6266rem;\n}\n#detailTop #ele_video[data-v-1ff9c303] {\n  width: 100%;\n  height: 5.6266rem;\n}\n.has_play_img[data-v-1ff9c303]:before {\n  content: '';\n  background: url('https://cdn.yxvzb.com/img/playimg.png') no-repeat;\n  background-size: 100%;\n  width: 2rem;\n  height: 2rem;\n  position: absolute;\n  top: 1.5rem;\n  left: 50%;\n  z-index: 2;\n  margin-left: -1rem;\n}\n", ""]);

// exports
